import "select2";

class Checkout {
    constructor() {
        var self = this;
        this.$ = jQuery;
        var $checkoutAdresses = $(".address-select");

        var addressContainer = $(".addressLoader");

        //remove the &nbsp; from the delivery notice
        jQuery(document).ready(function ($) {
            // Remove the non-breaking space from the label
            $('#delivery_notice_id').contents().filter(function () {
                return this.nodeType === 3 && this.nodeValue.trim() === '';
            }).remove();
        });
        addressContainer.html('<img src="' + ajax.templateUrl + '/assets/svg/loading.svg' + '" alt="Loading" class="">');

        // AJAX request to retrieve the address data
        $.ajax({
            url: wc_add_to_cart_params.ajax_url,
            method: 'POST',
            dataType: 'json',
            data: {
                action: 'gpa_select_address',
            },
            success: function (response) {
                addressContainer.html('');
                if (response.address && response.address.length > 0) {
                    $('.select-address-wrapper').removeClass('d-none');

                    const addressData = Object.values(response.address).map((address) => {
                        let addressDetails = Object.values(address).join(' ');
                        const regex = /(\d{3}\s?\d{2})\s+(.+)/;
                        const address4 = address.address4;
                        let addressName = address.addressName;
                        if (addressName == '') {
                            addressName = address.address1
                        }
                        const zipNumbersOnly = address4.replace(/\D/g, "");
                        const match = regex.exec(address4);
                        let city = '';
                        if (match) {
                            city = match[2];
                        }
                        return { id: address.addressNo, text: `${addressDetails} `, addressName: addressName, address: address.address3, address2: address.address2, name: address.name, lastname: address.lastname, company: address.address1, country: address.country, zip: zipNumbersOnly, city: city, phone: address.phone, name_profile: response.name, lastname_profile: response.last_name }
                    })

                    // Use the address data as needed
                    self.processAddressData(addressData);
                }
            },
            error: function (xhr, status, error) {
                // Handle error if the request fails
                console.error(error);
            }
        });

        // Add event listener using jQuery syntax
        $('input[name="store_pickup"]').on('change', function () {
            $('#billing_address_2').val(($(this).is(':checked')) ? "Afhentes i butik" : "");

            if ($(this).is(':checked')) {
                $('#billing_address_2').attr('disabled', 'disabled');
                $('.select-address-wrapper').addClass('d-none');
            } else {
                $('#billing_address_2').removeAttr('disabled');
                $('.select-address-wrapper').removeClass('d-none');
            }
        });
        $('input[name="delivery_store_checkbox"]').on('change', function () {
            $('#billing_address_2').val(($(this).is(':checked')) ? "Hämtas på lagret i Hjärnarp" : "");

            if ($(this).is(':checked')) {
                $('#billing_address_2').attr('disabled', 'disabled');
                $('.select-address-wrapper').addClass('d-none');
            } else {
                $('#billing_address_2').removeAttr('disabled');
                $('.select-address-wrapper').removeClass('d-none');
            }
        });
    }

    processAddressData(dataaddress) {
        const checkoutAdresses = $(".address-select");
        checkoutAdresses.select2({

            //add the data to the select2 element
            data: dataaddress,
            placeholder: "Välj adress",
            allowClear: false,
            templateResult: function (data) {
                var customElement = $('<span class="custom-option">' + data.addressName + '</span>');

                return customElement;
            }



        });
        // Update the displayed text when an option is selected
        checkoutAdresses.on('select2:select', function (e) {
            var selectedOption = e.params.data;
            var selectedText = selectedOption.addressName;

            $(this).siblings('.select2').find('.select2-selection__rendered').html(selectedText);

            $('#billing_first_name').val(selectedOption.name || selectedOption.name_profile);
            $('#billing_last_name').val(selectedOption.lastname || selectedOption.lastname_profile);
            $('#billing_company').val(selectedOption.company);
            $('#select2-billing_country-container').text(selectedOption.country);
            $('#billing_address_1').val(selectedOption.address);
            $('#billing_address_2').val(selectedOption.address2);
            $('#billing_postcode').val(selectedOption.zip);
            $('#billing_city').val(selectedOption.city);


        });


        const deliveryCheckbox = $('input[name="delivery_notice_checkbox"]');

        // Add event listener using jQuery syntax
        $(deliveryCheckbox).on('change', function () {
            if (this.checked) {
                $('.delivery-notice-phone').removeClass('d-none');
            } else {
                $('.delivery-notice-phone').addClass('d-none');
            }
        });
    }



}
export default Checkout;